import DataTable from 'react-data-table-component'
import OperatorsApiManager from '../../api/services/OperatorsApiManager'
import ConfigApiManager from '../../api/services/ConfigApiManager'
import { useState, useEffect } from 'react'
import { Button, Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import ReactPlayer from 'react-player'
import { Link } from 'react-router-dom'
import CryptoJS from 'crypto-js'
import { useTranslation } from 'react-i18next'
import useIsMobile from '../../hooks/useIsMobile'
/**
 * Convierte una cadena Base64 a una versión segura para URLs
 * @param {string} base64 - La cadena Base64 original
 * @returns {string} - La cadena Base64 segura para URLs
 */
function toBase64UrlSafe(base64) {
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

/**
 * Convierte una cadena Base64 segura para URLs de vuelta a Base64 estándar
 * @param {string} base64UrlSafe - La cadena Base64 segura para URLs
 * @returns {string} - La cadena Base64 estándar
 */
function fromBase64UrlSafe(base64UrlSafe) {
    return base64UrlSafe
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(
            base64UrlSafe.length + ((4 - (base64UrlSafe.length % 4)) % 4),
            '='
        )
}
function encryptUrl(url) {
    try {
        if (!url || typeof url !== 'string') {
            throw new Error('URL must be a non-empty string')
        }
        // Generate a random initialization vector
        const iv = CryptoJS.lib.WordArray.random(16)
        // Encrypt the URL using AES encryption
        const key = CryptoJS.enc.Hex.parse(import.meta.env.VITE_ENCRYPTION_KEY)

        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(url), key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        })

        // Convert IV and ciphertext to Base64 URL-safe
        const ivBase64UrlSafe = toBase64UrlSafe(
            CryptoJS.enc.Base64.stringify(iv)
        )
        const ciphertextBase64UrlSafe = toBase64UrlSafe(
            CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
        )

        // Return the IV and ciphertext as a single string
        return `${ivBase64UrlSafe}:${ciphertextBase64UrlSafe}`
    } catch (error) {
        throw new Error(`Encryption failed: ${error.message}`)
    }
}

const BASE_URL = import.meta.env.VITE_BASE_PROXY_URL

const customStyles = {
    pagination: {
        style: {
            order: -1,
            marginBottom: '1rem',
        },
    },
}

function Canales() {
    const { t } = useTranslation()
    const isMobile = useIsMobile()
    const [canalesData, setCanalesData] = useState([])
    const [canales, setCanales] = useState([])
    const [showPreviewPlayer, setShowPreviewPlayer] = useState(false)
    const [selectedChannel, setSelectedChannel] = useState(null)
    const [currentUrl, setCurrentUrl] = useState('')
    const [selectedOperator, setSelectedOperator] = useState(null)
    const [isProxyEnabled, setIsProxyEnabled] = useState(false)
    const paginacionOpciones = {
        rowsPerPageText: t('paginator.rowsPerPageText'),
        rangeSeparatorText: t('paginator.rangeSeparatorText'),
        selectAllRowsItemText: t('paginator.selectAllRowsItemText'),
    }
    useEffect(() => {
        async function fetchCanales() {
            const canalesItems = await OperatorsApiManager.getOperatorChannels()

            setCanales(canalesItems)
            setCanalesData(canalesItems)

            var operatorData = localStorage.getItem('operador')
            var operator = JSON.parse(operatorData)
            setSelectedOperator(operator)

            try {
                const basicParams = await ConfigApiManager.getBasicParams()
                if (basicParams && Array.isArray(basicParams)) {
                    const proxyConfig = basicParams.find(
                        (p) => p.key === 'is_proxy_enabled'
                    )
                    if (proxyConfig && proxyConfig.value === '1') {
                        setIsProxyEnabled(true)
                    } else {
                        setIsProxyEnabled(false)
                    }
                }
            } catch (error) {
                console.error('Error fetching config:', error)
                setIsProxyEnabled(false) // Default to false if error
            }
        }
        fetchCanales()
    }, [])

    const getUrlForPlayer = (channel, useProxy) => {
        if (!useProxy) {
            return channel.field_url
        }

        if (channel.field_url.endsWith('.mp4')) {
            const urlEncrypted = encryptUrl(channel.field_url)
            const randomString = Math.random().toString(36).substring(2, 15)
            let fakeEncryptedUrl = BASE_URL + randomString

            let urlWithParams =
                fakeEncryptedUrl +
                '&encryptedUrl=' +
                urlEncrypted +
                '&apiKey=' +
                import.meta.env.VITE_API_KEY
            return urlWithParams
        } else {
            const randomString = Math.random().toString(36).substring(2, 15)
            let fakeEncryptedUrl = randomString
            return BASE_URL + fakeEncryptedUrl
        }
    }

    const nextChannel = () => {
        const currentIndex = canales.findIndex(
            (canal) => canal.nid === selectedChannel.nid
        )
        const nextIndex = (currentIndex + 1) % canales.length
        setSelectedChannel(canales[nextIndex])

        if (canales[nextIndex]) {
            setCurrentUrl(getUrlForPlayer(canales[nextIndex], isProxyEnabled))
        }
    }
    const prevChannel = () => {
        const currentIndex = canales.findIndex(
            (canal) => canal.nid === selectedChannel.nid
        )
        const prevIndex = (currentIndex - 1 + canales.length) % canales.length
        setSelectedChannel(canales[prevIndex])

        if (canales[prevIndex]) {
            setCurrentUrl(getUrlForPlayer(canales[prevIndex], isProxyEnabled))
        }
    }
    const columns = [
        {
            name: t('options_title'),
            selector: (row) => (
                <>
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">
                                {t('preview_channel')}
                            </Tooltip>
                        }
                    >
                        <span className="d-inline-block">
                            <Button
                                variant="btn-rounded outline-secondary btn-icon"
                                onClick={(event) => {
                                    event.preventDefault()
                                    setShowPreviewPlayer(true)
                                    setSelectedChannel(row)
                                    console.log(row)
                                    setCurrentUrl(
                                        getUrlForPlayer(row, isProxyEnabled)
                                    )
                                }}
                            >
                                <i className="mdi mdi-eye btn-icon-prepend text-info"></i>
                            </Button>
                        </span>
                    </OverlayTrigger>
                </>
            ),
            sortable: false,
        },
        {
            name: 'ID',
            selector: (row) => row.nid,
            sortable: true,
            hide: 'sm',
        },
        {
            name: t('logo_title'),
            selector: (row) => (
                <img
                    width={50}
                    height={50}
                    src={`https://portal.ok-television.com${row.field_logo}`}
                ></img>
            ),
            sortable: false,
        },
        {
            name: t('name_title'),
            selector: (row) => row.title,
            sortable: true,
        },
        {
            name: t('category_title'),
            selector: (row) => row.field_channel_category,
            sortable: true,
        },
    ]

    const canalesCards = canales.map((canal) => (
        <Card key={canal.nid} className="cardM">
            <Card.Body>
                <div className="d-flex align-items-center">
                    <img
                        src={`https://portal.ok-television.com${canal.field_logo}`}
                        alt={canal.title}
                        width={50}
                        height={50}
                        style={{
                            objectFit: 'contain',
                            marginRight: 12,
                        }}
                    />
                    <div>
                        <div className="fw-bold">{canal.title}</div>
                        <div className="text-muted" style={{ fontSize: 13 }}>
                            {canal.field_channel_category}
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">
                                {t('preview_channel')}
                            </Tooltip>
                        }
                    >
                        <span className="d-inline-block">
                            <Button
                                variant="btn-rounded outline-secondary btn-icon"
                                onClick={(event) => {
                                    event.preventDefault()
                                    setShowPreviewPlayer(true)
                                    setSelectedChannel(canal)
                                    setCurrentUrl(
                                        getUrlForPlayer(canal, isProxyEnabled)
                                    )
                                }}
                            >
                                <i className="mdi mdi-eye btn-icon-prepend text-info"></i>
                            </Button>
                        </span>
                    </OverlayTrigger>
                </div>
            </Card.Body>
        </Card>
    ))

    return (
        <div>
            <div className="page-header">
                <h3 className="page-title">{selectedOperator?.group_name}</h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/operadores" className="breadcrumb-link">
                                {t('operators_title')}
                            </Link>
                        </li>
                        <li
                            className="breadcrumb-item active"
                            aria-current="page"
                        >
                            {t('channels_title')}
                        </li>
                    </ol>
                </nav>
            </div>
            <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">
                                {t('channels_title')}
                            </h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t('search_placeholder')}
                                        onChange={(e) => {
                                            if (e.target.value === '') {
                                                setCanales(canalesData)
                                                return
                                            }

                                            const searchTerm =
                                                e.target.value.toLowerCase()
                                            const filteredCanales =
                                                canalesData.filter(
                                                    (canal) =>
                                                        canal.title
                                                            .toLowerCase()
                                                            .includes(
                                                                searchTerm
                                                            ) ||
                                                        canal.field_channel_category
                                                            .toLowerCase()
                                                            .includes(
                                                                searchTerm
                                                            ) ||
                                                        canal.nid
                                                            .toLowerCase()
                                                            .includes(
                                                                searchTerm
                                                            )
                                                )
                                            setCanales(filteredCanales)
                                        }}
                                    />
                                </div>
                                <div
                                    className={
                                        isMobile
                                            ? 'col-12 text-left mb-2'
                                            : 'col-md-6 text-right text-center'
                                    }
                                >
                                    <span className="text-muted">
                                        {t('channels_count')}
                                        <strong>{canalesData.length}</strong>
                                    </span>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                {isMobile ? (
                                    <div>{canalesCards}</div>
                                ) : (
                                    <DataTable
                                        columns={columns}
                                        data={canales}
                                        paginationComponentOptions={
                                            paginacionOpciones
                                        }
                                        pagination
                                        customStyles={customStyles}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal video starts */}
                <Modal
                    show={showPreviewPlayer}
                    onHide={() => setShowPreviewPlayer(false)}
                    fullscreen={true}
                    aria-labelledby="example-modal-sizes-title-md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t('channel_title')} {selectedChannel?.title}{' '}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <ReactPlayer
                            url={currentUrl}
                            controls={true}
                            playing={true}
                            height="100%"
                            width="100%"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                margin: '0 auto',
                                display: 'block',
                                borderRadius: '0px',
                            }}
                            config={{
                                file: {
                                    attributes: {
                                        controlsList: 'nodownload', // Opcional: evita descargas
                                        crossOrigin: 'true',
                                    },
                                    forceHLS:
                                        selectedChannel?.field_url?.endsWith(
                                            '.m3u8'
                                        ), // Fuerza el uso de HLS
                                    hlsOptions: isProxyEnabled
                                        ? {
                                              // Configuración de HLS
                                              xhrSetup: function (xhr, url) {
                                                  var urlEncrypted = encryptUrl(
                                                      selectedChannel.field_url
                                                  )
                                                  //Validar si tiene ya parametros y agregarlo, en caso que no, agregarlo solo
                                                  let urlWithParams = url
                                                  if (
                                                      urlWithParams.indexOf(
                                                          '?'
                                                      ) !== -1
                                                  ) {
                                                      urlWithParams +=
                                                          '&encryptedUrl=' +
                                                          urlEncrypted
                                                  } else {
                                                      urlWithParams +=
                                                          '?encryptedUrl=' +
                                                          urlEncrypted
                                                  }
                                                  xhr.open(
                                                      'GET',
                                                      urlWithParams,
                                                      true
                                                  )
                                                  xhr.setRequestHeader(
                                                      'x-api-key',
                                                      import.meta.env.VITE_API_KEY
                                                  )
                                              },
                                          }
                                        : {},
                                },
                            }}
                        />
                    </Modal.Body>

                    <Modal.Footer className="flex-wrap">
                        <Button
                            variant="outline-info btn-icon-text"
                            onClick={() => {
                                prevChannel()
                            }}
                        >
                            <i className="mdi mdi-chevron-left btn-icon-prepend"></i>
                            {t('button.back')}
                        </Button>

                        <Button
                            variant="outline-info btn-icon-text"
                            onClick={() => {
                                nextChannel()
                            }}
                        >
                            {t('button.next')}
                            <i className="mdi mdi-chevron-right btn-icon-append"></i>
                        </Button>
                        <Button
                            variant="primary m-2 btn-icon-text"
                            onClick={() => setShowPreviewPlayer(false)}
                        >
                            {t('button.close')}
                            <i className="mdi mdi-close btn-icon-append"></i>
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/* Modal video Ends */}
            </div>
        </div>
    )
}

export default Canales
